import { jsx as _jsx } from "react/jsx-runtime";
import BrandAbout from "@/components/Brand/About";
import { withBrandLayout } from "@/modules/lab/components/BrandLayout";
const AuthorLabsInfoPage = ()=>{
    return /*#__PURE__*/ _jsx(BrandAbout, {});
};
export var __N_SSP = true;
export default withBrandLayout(AuthorLabsInfoPage);
